// extracted by mini-css-extract-plugin
export default {"photo":"FeedPhotoItem_photo__0PiKu","views":"FeedPhotoItem_views__6jXcO"};